import React, { Component, Fragment } from "react";
import ProgressChart from "../../../../../d3Components/progressChart/progressChart";
// import Spinner from "../../../Datatable/spinner/spinner";

class ProgressHolder extends Component {
  _isMounted = false;
  state = {
    output: []
  };
  componentDidMount() {
    const { getBacktest, getRiskStatistics } = this.props;
    this.dataModify(getRiskStatistics, getBacktest);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  dataModify = (getRiskStatistics, getBacktest) => {
    if (getRiskStatistics) {
      let portfolio_metrics = getBacktest.getPortfolioMetrics;
      let output = [];
      var { typeName } = this.props;
      let TypeName = typeName
        ? `${typeName} Total Returns`
        : "BENCHMARK TOTAL RETURN";
      this._isMounted = true;
      let portfolio_vami = getBacktest.getPortfolioVami;
      let benchmark_vami = getBacktest.getBenchmarkVami;

      let YourPortfolio = typeName === "IQCIO Model" ? "Your Portfolio" : null;
      let fund_name = portfolio_vami[0].scenario_name
        ? portfolio_vami[0].scenario_name
        : YourPortfolio;
      let fund_val = 0;
      let benchmark_val = 0;
      getRiskStatistics.forEach(function(val) {
        if ("Fund Total Return" === val.metric_name) {
          fund_val = parseFloat(val.fund).toFixed(2);
        } else if ("Benchmark Total Return" === val.metric_name) {
          benchmark_val = parseFloat(val.fund).toFixed(2);
        }
      });

      output.push(
        {
          name: fund_name,
          value: fund_val + "%",
          percent: fund_val
        },
        {
          name: TypeName,
          value: benchmark_val + "%",
          percent: benchmark_val
        }
      );
      for (let i in portfolio_metrics[0]) {
        let line = portfolio_metrics[0][i];
        switch (i) {
          case "fund_annualized_vol":
            output.push({
              name: "Portfolio Anualized Vol",
              value: line + "%",
              percent: parseFloat(line).toFixed(2)
            });
            break;
          case "fund_annualized_return":
            output.push({
              name: "Portfolio Annualized Return",
              value: line + "%",
              percent: parseFloat(line).toFixed(2)
            });
            break;
          default:
        }
      }
      this.setState({
        output: output
      });
    }
  };
  render() {
    const { output } = this.state;
    return (
      <Fragment>
        <div className="my-5">
          {output.length > 0 ? (
            <ul
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center"
              }}
            >
              {output[0] == null ? null : (
                <li>
                  {Object.keys(output[0]).length > 0 && output[0]["percent"] ? (
                    <ProgressChart
                      width={200}
                      height={200}
                      data={output[0]}
                      id="progress_1"
                    />
                  ) : null}
                </li>
              )}
              {output[1] == null ? null : (
                <li>
                  {Object.keys(output[1]).length > 0 && output[1]["percent"] ? (
                    <ProgressChart
                      width={200}
                      height={200}
                      data={output[1]}
                      id="progress_2"
                    />
                  ) : null}
                </li>
              )}
              {output[2] == null ? null : (
                <li>
                  {Object.keys(output[2]).length > 0 && output[2]["percent"] ? (
                    <ProgressChart
                      width={200}
                      height={200}
                      data={output[2]}
                      id="progress_3"
                    />
                  ) : null}
                </li>
              )}
              {output[3] == null ? null : (
                <li>
                  {Object.keys(output[3]).length > 0 && output[3]["percent"] ? (
                    <ProgressChart
                      width={200}
                      height={200}
                      data={output[3]}
                      id="progress_4"
                    />
                  ) : null}
                </li>
              )}
            </ul>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default ProgressHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/statistic/section1/ProgressHolder.jsx